<script>
import AdminContractSchetSummPagePechat from "~/src/components/AdminContractSchetSummLotinPagePechat.vue";
import "viewerjs/dist/viewer.css";
import Viewer from "viewerjs";

export default {
  name: "Report",

  components: { AdminContractSchetSummPagePechat },

  data: () => ({
    id: 0,

    allowance: null,

    isLoading: false,

    isInvoicePechat: false,

    pdfData: null,
  }),

  created() {
    this.id = Number(this.$route.params.id);
    this.init();
  },

  methods: {
    async init() {
      this.isLoading = true;
      const data = await this.$axios.$get(`/report/contract2024/${this.id}`);
      if (data) {
        this.pdfData = data;
        this.allowance = data?.fullName ? data : null;
      }
      this.isLoading = false;
    },

    async onDownloadContractInvoicePechat() {
      this.isLoading = true;
      if (this.pdfData) {
        this.$nextTick(() => (this.isInvoicePechat = true));
      } else {
        this.isLoading = false;
      }
    },

    getFacultyCodeAndName(v) {
      return v?.mvdir + " - " + v?.educationFacultyName || null;
    },

    getName(pdfData) {
      let yearStudy;
      switch (pdfData.id) {
        case 3:
          if (pdfData.typeAbiturient == "SECOND_SPES") {
            yearStudy = "4 yil";
          } else {
            yearStudy = "5 yil";
          }
          break;
        case 6:
          if (pdfData.typeAbiturient == "SECOND_SPES") {
            yearStudy = "4 yil";
          } else {
            yearStudy = "5 yil";
          }
          break;
        case 9:
          if (pdfData.typeAbiturient == "SECOND_SPES") {
            yearStudy = "4 yil";
          } else {
            yearStudy = "5 yil";
          }
          break;
        case 12:
          if (pdfData.typeAbiturient == "SECOND_SPES") {
            yearStudy = "4 yil";
          } else {
            yearStudy = "5 yil";
          }
          break;
        /* case 15:
              yearStudy = "5-йил";
              break;*/
        case 18:
          if (pdfData.typeAbiturient == "SECOND_SPES") {
            yearStudy = "4 yil";
          } else {
            yearStudy = "5 yil";
          }
          break;
        case 23:
          if (pdfData.typeAbiturient == "SECOND_SPES") {
            yearStudy = "4 yil";
          } else {
            yearStudy = "5 yil";
          }
          break;
        case 26:
          if (pdfData.typeAbiturient == "SECOND_SPES") {
            yearStudy = "4 yil";
          } else {
            yearStudy = "5 yil";
          }
          break;
        case 29:
          if (pdfData.typeAbiturient == "SECOND_SPES") {
            yearStudy = "4 yil";
          } else {
            yearStudy = "5 yil";
          }
          break;
        case 32:
          if (pdfData.typeAbiturient == "SECOND_SPES") {
            yearStudy = "4 yil";
          } else {
            yearStudy = "5 yil";
          }
          break;
        case 13:
          if (pdfData.typeAbiturient == "SECOND_SPES") {
            yearStudy = "2 yil";
          } else {
            yearStudy = "3 yil";
          }
          break;
        case 14:
          if (pdfData.typeAbiturient == "SECOND_SPES") {
            yearStudy = "2 yil";
          } else {
            yearStudy = "3 yil";
          }
          break;
        default:
          if (pdfData.typeAbiturient == "SECOND_SPES") {
            yearStudy = "3 yil";
          } else {
            yearStudy = "4 yil";
          }
          break;
      }
      return yearStudy;
    },

    getKursName(v) {
      return v == "1-kurs" ? "1 kurs" : "2 kurs";
    },

    getSummContract(v) {
      return v?.summ_n + " so'm" || null;
    },

    onShowImage(e) {
      this.$nextTick(() => {
        const gallery = new Viewer(e.target, {
          title: true,
          hidden: () => {
            gallery.destroy();
          },
        });

        gallery.show();
      });
    },
  },
};
</script>

<template>
  <main v-if="allowance">
    <admin-contract-schet-summ-page-pechat
      v-if="isInvoicePechat && pdfData"
      :pdf-data="pdfData"
      @close="
        () => {
          isInvoicePechat = false;
          isLoading = false;
        }
      "
    />
    <section class="section-login">
      <div class="section-main">
        <div class="section-login-1">
          <div class="section-login-1-main">
            <div class="section-login-1-img">
              <a
                href="https://usat.uz/"
                title="Bosh sahifaga o'tish"
                target="_blank"
                ><img src="@/assets/img/about_usat.png" alt=""
              /></a>
            </div>
            <div class="section-login-1-media">
              <a href="https://t.me/usatuzb"
                ><i class="fab fa-telegram-plane"></i
              ></a>
              <a href="https://instagram.com/usatuz"
                ><i class="fab fa-instagram"></i
              ></a>
              <a href="https://facebook.com/usatuz"
                ><i class="fab fa-facebook"></i
              ></a>
            </div>
            <p class="section-login-1-text">Call-center: +(99878) 888-38-88</p>

            <div class="d-flex">
              <img
                width="70"
                @click="onShowImage"
                src="../../assets/img/lisence1.png"
                alt="Page 1"
              />
              <div class="px-1" />
              <img
                width="70"
                @click="onShowImage"
                src="../../assets/img/lisence2.png"
                alt="Page 2"
              />
            </div>
          </div>
        </div>
        <div class="section-login-2">
          <div class="login-logo">
            <img src="@/assets/img/logo-inline.png" alt="USAT logo" />
          </div>
          <div class="section-login-2-main">
            <div class="-cart">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" colspan="2">
                        <h3>Talaba ma'lumotlari</h3>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Talaba F.I.Sh.</td>
                      <td
                        colspan="3"
                        class="text-upper"
                        v-text="allowance.fullName"
                      />
                    </tr>
                    <tr>
                      <td>Ta'lim turi</td>
                      <td>BAKALAVR</td>
                    </tr>
                    <tr>
                      <td>Ta'lim shakli</td>
                      <td
                        colspan="3"
                        class="text-upper"
                        v-text="allowance.educationTypeName"
                      />
                    </tr>
                    <tr>
                      <td>O'qish muddati</td>
                      <td
                        colspan="3"
                        class="text-upper"
                        v-text="getName(allowance)"
                      />
                    </tr>
                    <tr>
                      <td>O'qish kursi</td>
                      <td
                        colspan="3"
                        class="text-upper"
                        v-text="getKursName(allowance.kurs)"
                      />
                    </tr>
                    <tr>
                      <td class="text-left" colspan="2">
                        <h4>Shartnoma ma'lumotlari</h4>
                      </td>
                    </tr>
                    <tr>
                      <td>Ta'lim yo'nalishi</td>
                      <td
                        colspan="3"
                        class="text-upper"
                        v-text="getFacultyCodeAndName(allowance)"
                      />
                    </tr>
                    <tr>
                      <td>Shartnoma raqami</td>
                      <td
                        colspan="3"
                        class="text-upper"
                        v-text="allowance.facultyCode"
                      />
                    </tr>
                    <tr>
                      <td>Shartnoma sanasi</td>
                      <td
                        colspan="3"
                        class="text-upper"
                        v-text="allowance.contractDate"
                      />
                    </tr>
                    <tr>
                      <td>Shartnoma summasi</td>
                      <td
                        colspan="3"
                        class="text-upper"
                        v-text="getSummContract(allowance)"
                      />
                    </tr>
                    <tr>
                      <td>Shartnoma nusxasi</td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="transform-none"
                              @click="onDownloadContractInvoicePechat"
                            >
                              NUSXA OLISH
                            </v-btn>
                          </template>
                          <span>{{ $t("download_сontract") }}</span>
                        </v-tooltip>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left" colspan="2">
                        <h4>Universitet ma'lumotlari</h4>
                      </td>
                    </tr>
                    <tr>
                      <td>Universitet web sahifasi</td>
                      <td>
                        <a href="https://usat.uz/" target="_blank"
                          >https://usat.uz
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
          <div class="section-login-1-media-none">
            <div class="section-login-1-media">
              <a href="https://t.me/usatuzb"
                ><i class="fab fa-telegram-plane"></i
              ></a>
              <a href="https://instagram.com/usatuz"
                ><i class="fab fa-instagram"></i
              ></a>
              <a href="https://facebook.com/usatuz"
                ><i class="fab fa-facebook"></i
              ></a>
            </div>
            <p class="section-login-1-text">Call-center: +(99878) 888-38-88</p>
            <div class="d-flex lisence">
              <img
                width="70"
                @click="onShowImage"
                src="../../assets/img/lisence1.png"
                alt="Page 1"
              />
              <div class="px-1" />
              <img
                width="70"
                @click="onShowImage"
                src="../../assets/img/lisence2.png"
                alt="Page 2"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<style lang="scss" scoped>
.-cart {
  background: rgba(154, 154, 154, 0.2);
  border-radius: 10px;
  padding: 10px;
  height: 100%;
  width: 100%;
}
.-actions {
  padding-top: 25px;
  display: flex;

  @media only screen and(max-width:599px) {
    flex-direction: column-reverse;
  }
}
main {
  width: 100%;
  height: auto;
}

.lisence {
  justify-content: center;
}

.login-logo {
  width: 80%;
  height: auto;
  display: none !important;
}

.login-logo img {
  margin-top: 25px;
  width: 100%;
  height: auto;
}

main section.section-login {
  width: 100vw;
  min-height: 100vh;
  background-color: #ffcb05;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-block: 10px;
}

main section.section-login .section-main {
  width: 80%;
  height: auto;
  display: flex;
  border-radius: 10px;
  overflow: hidden;
}

main section.section-login .section-main .section-login-1,
main section.section-login .section-login-2 {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #00274c;
}

main
  section.section-login
  .section-main
  .section-login-1
  .section-login-1-main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 50px;
}

.section-login-1-media {
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.section-login-1-media a {
  width: 45px;
  height: 45px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  margin: 0 7px 10px;
  color: #00274c;
  background-color: #ffcb05;
  font-size: 20px;
  transition: all 300ms ease;
}

.section-login-1-media a:hover,
.section-login-1-media a:focus {
  transform: translateY(-10px);
}

.section-login-1-text {
  color: #fff;
  font-size: 18px;
}

main
  section.section-login
  .section-main
  .section-login-1
  .section-login-1-main
  .section-login-1-img {
  width: 100%;
  margin-left: -35px;
}

main
  section.section-login
  .section-main
  .section-login-1
  .section-login-1-main
  .section-login-1-img
  img {
  width: 100%;
  display: block;
}

.section-login-1-media-none {
  display: none;
}

.section-login-1-media-none .section-login-1-media a {
  background-color: #00274c;
  color: #ffffff;
}

.section-login-1-media-none .section-login-1-text {
  color: #00274c;
  font-weight: 500;
}

main
  section.section-login
  .section-main
  .section-login-2
  .section-login-2-main {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px;
}

main
  section.section-login
  .section-main
  .section-login-2
  .section-login-2-main
  .section-login-2-title {
  font-size: 32px;
  font-weight: 600;
  line-height: 0.8;
}

main
  section.section-login
  .section-main
  .section-login-2
  .section-login-2-main
  .section-login-2-form {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}

main
  section.section-login
  .section-main
  .section-login-2
  .section-login-2-main
  .section-login-2-form
  .login-form-2,
main
  section.section-login
  .section-main
  .section-login-2
  .section-login-2-main
  .section-login-2-form
  .login-form-3 {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

a {
  text-decoration: none;
}

main
  section.section-login
  .section-main
  .section-login-2
  .section-login-2-main
  .section-login-2-form
  .login-form-2
  label,
main
  section.section-login
  .section-main
  .section-login-2
  .section-login-2-main
  .section-login-2-form
  .login-form-3
  label {
  font-weight: 500;
  font-size: 15px;
}

main
  section.section-login
  .section-main
  .section-login-2
  .section-login-2-main
  .section-login-2-form
  .login-form-4 {
  display: flex;
  column-gap: 7px;
  align-items: center;
}

main
  section.section-login
  .section-main
  .section-login-2
  .section-login-2-main
  .section-login-2-form
  .login-form-4
  p,
main
  section.section-login
  .section-main
  .section-login-2
  .section-login-2-main
  .section-login-2-form
  .login-form-5
  p {
  font-size: 14px;
}

main
  section.section-login
  .section-main
  .section-login-2
  .section-login-2-main
  .section-login-2-form
  .login-form-4
  p
  a,
main
  section.section-login
  .section-main
  .section-login-2
  .section-login-2-main
  .section-login-2-form
  .login-form-5
  p
  a {
  font-weight: bold;
  color: #00274c;
}

main
  section.section-login
  .section-main
  .section-login-2
  .section-login-2-main
  .section-login-2-form
  .login-form-5
  p {
  text-align: center;
}

@media only screen and (max-width: 1200px) {
  main section.section-login .section-login-1 .section-login-1-main,
  main section.section-login .section-login-2 .section-login-2-main {
    width: 85%;
  }

  main
    section.section-login
    .section-login-1
    .section-login-1-main
    .section-login-1-title,
  main
    section.section-login
    .section-login-1
    .section-login-1-main
    .section-login-1-form {
    margin-top: 35px;
  }

  main section.section-login .section-main {
    width: 75%;
  }
}

@media only screen and (max-width: 806px) {
  main section.section-login .section-main {
    padding: 35px 0px;
  }

  main section.section-login .section-login-1 .section-login-1-main,
  main section.section-login .section-login-2 .section-login-2-main {
    width: 90%;
  }

  main section.section-login .section-login-1 .section-login-1-main {
    height: 90%;
  }

  main
    section.section-login
    .section-login-1
    .section-login-1-main
    .section-login-1-title,
  main
    section.section-login
    .section-login-1
    .section-login-1-main
    .section-login-1-form {
    margin-top: 25px;
  }

  main section.section-login .section-main {
    flex-direction: column-reverse;
    width: 85%;
    padding: 50px 0px;
  }

  main section.section-login .section-main .section-login-1,
  main section.section-login .section-login-2 {
    width: 100%;
  }

  main section.section-login {
    height: unset;
  }

  main section .login-logo {
    display: block !important;
    margin-bottom: 30px;
  }

  .section-login-1 {
    display: none !important;
  }

  main section.section-login .section-login-2 {
    background-color: transparent;
  }

  main
    section.section-login
    .section-main
    .section-login-2
    .section-login-2-main {
    border-radius: 15px;
  }

  .section-login-2 .section-login-1-media-none {
    display: block !important;
    margin-bottom: 0px;
  }
}

@media only screen and (max-width: 600px) {
  main section.section-login .section-main {
    padding: 0;
  }

  main
    section.section-login
    .section-main
    .section-login-2
    .section-login-2-main {
    padding: 35px 25px;
  }

  .footer__file {
    margin-right: 10px;
    height: 130px;
    height: 120px;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .el-image {
    position: relative;
    display: inline-block;
    overflow: hidden;
  }
  .el-image__preview {
    cursor: pointer;
  }
  .el-image__inner {
    vertical-align: top;
    opacity: 1;
  }
  .el-image__error,
  .el-image__inner,
  .el-image__placeholder,
  .el-image__wrapper {
    width: 100%;
    height: 100%;
  }
  .el-image-viewer__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .el-image-viewer__mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0.5;
    background: #000;
  }
  .el-image-viewer__close {
    width: 44px;
    height: 44px;
    font-size: 24px;
    color: #fff;
    background-color: var(--el-text-color-regular);
    border-color: #fff;
  }
  .el-image-viewer__close {
    top: 40px;
    right: 40px;
    width: 40px;
    height: 40px;
    font-size: 40px;
  }
  .el-image-viewer__btn {
    position: absolute;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    opacity: 0.8;
    cursor: pointer;
    box-sizing: border-box;
    -webkit-user-select: none;
    user-select: none;
  }
  .el-image-viewer__next,
  .el-image-viewer__prev {
    top: 50%;
    transform: translateY(-50%);
    width: 44px;
    height: 44px;
    font-size: 24px;
    color: #fff;
    background-color: var(--el-text-color-regular);
    border-color: #fff;
  }
  .el-image-viewer__prev {
    left: 40px;
  }
  .el-image-viewer__btn {
    position: absolute;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    opacity: 0.8;
    cursor: pointer;
    box-sizing: border-box;
    -webkit-user-select: none;
    user-select: none;
  }
  .el-image-viewer__btn .el-icon {
    font-size: inherit;
    cursor: pointer;
  }
  .el-icon {
    --color: inherit;
    height: 1em;
    width: 1em;
    line-height: 1em;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    fill: currentColor;
    color: var(--color);
    font-size: inherit;
  }
  .el-image-viewer__next {
    right: 40px;
    text-indent: 2px;
  }
  .el-image-viewer__next,
  .el-image-viewer__prev {
    top: 50%;
    transform: translateY(-50%);
    width: 44px;
    height: 44px;
    font-size: 24px;
    color: #fff;
    background-color: var(--el-text-color-regular);
    border-color: #fff;
  }
  .el-image-viewer__actions {
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    width: 282px;
    height: 44px;
    padding: 0 23px;
    background-color: var(--el-text-color-regular);
    border-color: #fff;
    border-radius: 22px;
  }
  .el-image-viewer__actions__inner {
    width: 100%;
    height: 100%;
    text-align: justify;
    cursor: default;
    font-size: 23px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .el-image-viewer__canvas {
    position: static;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-user-select: none;
    user-select: none;
  }
}
</style>
